import styled from "@emotion/styled";
import Menu from "@mui/material/Menu";
import MuiMenuItem from "@mui/material/MenuItem";
import { useContext, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useLoggedInUser, useSignedInUser, useUserProfile } from "../../api/userInfo";
import downarrowIcon from "../../assets/images/ic_downArrow.png";
import { getLogOut } from "../../context/auth/auth_action";
import { AuthContext } from "../../context/auth/auth_context";
import { Link, useParams } from "react-router-dom";
import { useDempStore } from "src/context/stores";
import { API_URL } from "src/shared/config";

const MenuItem = styled(MuiMenuItem)`
  :hover {
    background-color: #eef5f7;
  }
`;

const MenuHeader = () => {
  const [dashboardId, companyId, plantId] = useDempStore((state) => [
    state.dashboardId,
    state.companyId,
    state.plantId,
  ]);
  const authContext = useContext(AuthContext);
  const { dispatch } = authContext;
  const { t, i18n } = useTranslation("main");
  const [anchorElMenu, setAnchorElMenu] = useState(null);
  const { userProfile } = useUserProfile();
  const { lang } = useParams();
  const firstLetter = userProfile?.first_name ? userProfile?.first_name?.charAt(0)?.toUpperCase(): "";
  
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const onMenuOpen = (setState) => (event) => {
    setState(event.currentTarget);
    setIsMenuOpen(true);
  };

  const onMenuClose = (setState) => (event) => {
    setState(null);
    setIsMenuOpen(false);
  };

  const onLogOut = (event) => {
    getLogOut(dispatch);
    localStorage.clear();
  };

  const userRole = useMemo(() => {
    if (userProfile?.is_superuser) {
      return "(Super Admin)";
    } 
  }, [userProfile]);

  const MenuList = () => {
    return (
      <div className="w-full p-4">
        {userRole ? (
          <>
          <div className="flex items-center">
            <i className="text-xl ri-user-fill text-vekin"></i>
            <p className="px-2 text-base capitalize cursor-default">{userRole}</p>
          </div>
          <hr className="my-1 border-gray-300 border-1 " />
          </>
        ):""}
        <div className="flex items-center gap-2 mt-2 rounded-md cursor-pointer group">
          <i className="text-xl ri-profile-line text-vekin group-hover:no-underline"></i>
          <Link to={`/${lang}/profile`} className="text-base group-hover:underline">
            {t("main:header_menu.profile")}
          </Link>
        </div>
        <button
          type="button"
          onClick={onLogOut}
          className="flex items-center gap-2 mt-2 text-base text-red-400 rounded-md group"
        >
          <i className="text-xl ri-logout-box-r-line group-hover:no-underline"></i>
          <span className="group-hover:underline">
            {t("main:header_menu.sign_out")}
          </span>
        </button>
      </div>
    );
  };

  const MenuHeader = ({ children, anchorEl, setAnchorEl }) => {
    return (
      <Menu
        className="w-full mx-4 rounded-md shadow-xl"
        autoFocus={false}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={onMenuClose(setAnchorEl)}
        onClick={onMenuClose(setAnchorEl)}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        MenuListProps={{ disablePadding: true }}
      >
        {children}
      </Menu>
    );
  };

  return (
    <div className="flex">
      <div
        className="flex items-center h-full gap-4 cursor-pointer"
        style={{ marginLeft: 16, borderRadius: 0 }}
      >
        <div className="flex items-center justify-center w-8 h-8 text-md rounded-full bg-vekin/40">
          {/* <img alt="tempProfileIcon" className="w-8 h-8" src={tempProfile} /> */}
          <div>
            {!!userProfile?.profile_image ? (
              <img
                src={userProfile?.profile_image}
                alt="Profile"
                className="w-full h-full max-h-[2rem] object-cover rounded-full"
              />
            ) : (
              firstLetter
            )}
          </div>
        </div>

        <div
          onClick={onMenuOpen(setAnchorElMenu)}
          className="flex items-center gap-2"
        >
          <p className="capitalize text-nowrap">
            {userProfile?.first_name ? `${userProfile?.first_name} ${userProfile?.last_name}` : "No name"}
            <span className="pl-2 text-xs"> {userRole}</span>
          </p>
          {isMenuOpen ? (
            <i className="text-3xl ri-arrow-down-s-line"></i>
          ) : (
            <i className="text-3xl ri-arrow-up-s-line"></i>
          )}
        </div>

        <MenuHeader anchorEl={anchorElMenu} setAnchorEl={setAnchorElMenu}>
          <MenuList />
        </MenuHeader>
      </div>

      {/* <MenuHeader
        children={<MenuLangList />}
        anchorEl={anchorElMenuLang}
        setAnchorEl={setAnchorElMenuLang}
      /> */}
    </div>
  );
};

export default MenuHeader;
